var SCAAFFCustomerReferSetting = {
    "program": {
        "active": true,
        "shop": "moncah-fb.myshopify.com",
        "incentive": {
            "type": "percentage",
            "value": "10.00",
            "price_rule_id": 1371402928294,
            "coupon": "UPPROMOTE_CUSTOMER_REFERRAL"
        },
        "program": "ODc4MTk="
    },
    "design": {
        "refer_customer_button": {
            "refer_button_text": "Refer & Earn",
            "refer_background_color": "#e85c1d",
            "refer_text_color": "#ffffff",
            "web_position": "right-center",
            "mobile_position": "left-center"
        },
        "refer_customer_invite": {
            "popup_header": "Invite & Get 20% from friend's orders",
            "popup_description": "Send your friends a 10.00% discount off their purchase. Once they make a purchase, you'll earn 20% for each order as well! This reward can be redeemed for coupons.",
            "button_text_get_invite": "Get invite link",
            "button_copy_invite": "Copy invite link",
            "popup_background_color": "#e5400e",
            "popup_text_color": "#ffffff"
        },
        "refer_customer_incentive_popup": {
            "shop_header": "You got 10% Off",
            "shop_description": "Congrats! Your friend has gifted you a coupon. Coupon will be automatically applied at the checkout page.",
            "shop_button_text": "Shop now",
            "shop_background_color": "#1d85e8",
            "shop_text_color": "#ffffff"
        }
    }
}